import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const FooterOfParawargrtnawakan = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { RPW_para$, RPW_paraID } = value;
          return (
            <>
              {/* second row */}
              <div className="row pt2">
                <div className="col-lg-10 col-12">
                  <div className="row ">
                    <div className="col-lg-3 col-4">
                      <h3 className="bg-white tc mt2">
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={RPW_para$}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-4">
                      <h3 className="text-warning tc  mt1">پارە بە دۆلار</h3>
                    </div>
                    <div className="col-lg-2 col-4"></div>
                    <div className="col-lg-3 col-4">
                      <h3 className="bg-white tc mt2">
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={RPW_paraID}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-4 mt1">
                      <h3 className="text-warning tc ">پارە بە دینار</h3>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              {/* third row */}
              <br />
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfParawargrtnawakan;
